import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingLoadsReceiveAtom = createMutationAtomFactory(
  'trade.bookingLoadsReceive',
  (params: { bookingId: string }) => ({
    tradeBookingLoadsReceive: {
      __args: {
        bookingId: params.bookingId,
      },
      id: true,
      status: true,
    },
  }),
);
